//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import portal from '@/net/portal'
const pwdReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{10,}$/
export default {
    name: '',
    data() {
        return {
            pwdForm: {
                password: '',
                newPassword: '',
                confirmPassword: ''
            },
            passwordRules: {
                password: [{ required: true, message: '旧密码不能为空', trigger: 'blur' }, { type: 'string', min: 6, message: '长度不能小于6位' }],
                newPassword: [
                    {
                        required: true,
                        trigger: 'change',
                        validator: this.passwordValidate
                    }
                ],
                confirmPassword: [{ required: true, validator: this.repeatValidate, trigger: 'change' }]
            }
        }
    },
    methods: {
        submit() {
            this.$refs.pwdForm.validate(valid => {
                if (valid) {
                    portal
                        .changePassword({
                            body: this.pwdForm
                        })
                        .then(res => {
                            if (res.code == '0000') {
                                this.$Message.success('修改成功')
                                this.$store.commit('SET_PWDVISIBLE', false)
                            } else {
                                this.$Message.error(res.message)
                            }
                        })
                }
            })
        },
        passwordValidate(rule, value, callback) {
            const reg = new RegExp(pwdReg)
            if (!value) {
                callback(new Error('密码不能为空'))
            } else if (value.length < 10) {
                callback(new Error('长度不能小于10位'))
            } else if (value.length > 30) {
                callback(new Error('长度不能大于30位'))
            } else if (!reg.test(value)) {
                callback(new Error('密码需由数字和字母组成，至少10位'))
            } else {
                callback()
            }
        },
        repeatValidate(rule, value, callback) {
            if (!value) {
                callback(new Error('请再次输入密码'))
            } else if (value !== this.pwdForm.newPassword) {
                callback(new Error('两次密码输入不一致'))
            } else {
                callback()
            }
        }
    }
}
